import { gql } from "@apollo/client";

export const FETCH_TAXONOMY_SECTORS = gql`
  query TaxonomySectors {
    taxonomySectors
  }
`;

export const FETCH_TAXONOMY_MAPPING = gql`
  query TaxonomyMapping($sector: String, $activity: String, $goal: String) {
    taxonomyMapping(sector: $sector, activity: $activity, goal: $goal)
  }
`;